import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import DatePicker from '../../../../LaridaeApp/datepicker/container/DatePicker'
import { TablaDescargaProcesadaEnStockView } from '../components/TablaDescargaProcesadaEnStockView'
import { actualizarDatosParaMuiTable } from '../actions/TablaDescargaProcesadaEnStockActions'

const TablaDescargaProcesadaEnStock = (props) => {
  const { actualizarDatosParaMuiTable, roles } = props

  useEffect(() => {
    actualizarDatosParaMuiTable(new Date(), new Date(), roles)
  }, [actualizarDatosParaMuiTable, roles])

  const actualizarFechas = (fechaD, fechaH) => {
    actualizarDatosParaMuiTable(fechaD, fechaH, roles)
  }

  return (
    <>
      <div className='container-entre-fechas'>
        <DatePicker
          selectRange
          disabledFuture
          locale='es'
          onDateChange={actualizarFechas}
          titulo='Seleccione las fechas'
          value='fechas'
        />
      </div>
      <TablaDescargaProcesadaEnStockView />
    </>
  )
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}

const mapStateToProps = state => {
  return {
    roles: state.auth.roles
  }
}

const withRedux = connect(mapStateToProps, mapActionsToProps)

export default withRedux(TablaDescargaProcesadaEnStock)
